import { getApiOptionFrequency } from '@/lib/transformers/option/utils/get-api-option-frequency';
import { RouteSequenceApiV4Interface } from '@/types/api-types';

/**
 * Will calculate the overall frequency of a route by taking the first option and adding the
 * frequency of all other option segments that have the same number of transfers
 */
export const getApiRouteFrequency = (options: RouteSequenceApiV4Interface[]): number => {
  const firstOption = options[0];
  const firstOptionTransfers = firstOption?.numTransfers;

  if (firstOptionTransfers > 0) {
    const perHourAvg = getApiOptionFrequency(firstOption);
    return perHourAvg;
  }

  return options.reduce((accum, option) => {
    const { numTransfers } = option;
    if (firstOptionTransfers === numTransfers) {
      const perHourAvg = getApiOptionFrequency(option);
      return accum + (perHourAvg || 0);
    }
    return accum;
  }, 0);
};
